export const initialState = {
  product: null,
}

export const setProduct = (state, payload) => (
  { product: payload }
)

export const reset = () => initialState
